module.exports = __webpack_public_path__ + "static/media/self.74ee5223.jpg";